<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Customer Payments</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12" md="3" class="subtitle-2 text--primary" v-if="hideTotals != 'Y'">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Payments:</td>
                    <td>{{ TotalPayments | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          
          <v-col cols="9">
            <v-btn small color="primary" class="float-right" to="/receive-customer-payment">
              <v-icon left>mdi-plus</v-icon>New Payment Receipt
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-text-field label="Search" v-model="search"></v-text-field>
            <!-- start of table -->
            <v-data-table
              dense
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="AllPayments"
              :search="search"
            >
              <template v-slot:item.Amount="{ item }">
                {{
                item.Amount | currency
                }}
              </template>

              <template v-slot:item.date="{ item }">
                <span
                  style="display: inline-block; min-width: 80px; width: 80px"
                >{{ item.date | date }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn
                  color="accent"
                  text
                  :to="`/pos/sale-details/${item.invoice.id}`"
                >{{ item.invoice.DocNum }}</v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
export default {
  components: {},
  data: () => ({
    zeroValue: 0,
    SoldBy: null,
    PaymentMode: null,
    pageItems: 200,
    totalDebt: 0,
    search: "",
    AllPayments: [],
    TotalPayments: 0,
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Customer", value: "customer.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Payment Mode", value: "Account.Name" },
      { text: "Remarks", value: "PaymentRemarks" },
      { text: "Date", value: "date" }
    ],
    debtors: []
  }),
  computed: {
    hideTotals() {
     return localStorage.getItem("HideDebtorsTotal");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userRole() {
      return localStorage.getItem("userRole");
    }
  },
  methods: {
    getRecords() {
      const storeId = this.activeStore;
      const self = this;
      const data = {
        store_id: storeId,
        AccountId: self.PaymentMode,
        SoldBy: self.SoldBy,
        StartDate: self.date,
        EndDate: "",
      };

      const url = `/sale-payments-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
        //   console.log(res, " receipt res");
          if (res.ResultCode == 1200) {
            self.AllPayments = res.ResponseData.payments;
            self.TotalPayments = res.ResponseData.TotalAmountPaid;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getRecords()]);
  }
};
</script>